import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { debounce } from "../utils";

export const RIGHT_PANEL_PX_OFFSET = 180;
export const RIGHT_PANEL_MAX_VW = 60;

export const getDefaultPanelPx = (screenWidth) => {
	if (screenWidth > 1660) {
		return 360;
	}
	if (screenWidth > 1440) {
		return 320;
	}
	if (screenWidth > 1260) {
		return 260;
	}
	return 240;
};

const pxToVw = (px, screenWidth) => ((px + RIGHT_PANEL_PX_OFFSET) / screenWidth) * 100;

export const getRightPanelMinVw = (screenWidth = window.innerWidth) =>
	Math.min(pxToVw(getDefaultPanelPx(screenWidth), screenWidth), RIGHT_PANEL_MAX_VW);

export default function useMyReviewRightPanelWidth() {
	const manualWidth = useSelector(({ srProjectDocument }) => srProjectDocument.myReviewRightPanelWidth);
	const [screenWidth, setScreenWidth] = useState(window.innerWidth);

	useEffect(() => {
		const handleWindowResize = debounce(() => setScreenWidth(window.innerWidth), 150);
		window.addEventListener("resize", handleWindowResize);
		return () => window.removeEventListener("resize", handleWindowResize);
	}, []);

	const minVw = getRightPanelMinVw(screenWidth);
	if (manualWidth === null || manualWidth === undefined) {
		return minVw;
	}
	return Math.min(Math.max(Number(manualWidth), minVw), RIGHT_PANEL_MAX_VW);
}
